const cvData = {
  name: "Hirun Kolongahapitiya",
  title: "Data Engineer",
  location: "Colombo, Sri Lanka",
  contacts: {
    email: "hirunkolongahapitiya@gmail.com",
    phone: "+94 70 156 6697",
    github: "https://github.com/hirun-kolongahapitiya",       
    linkedin: "https://www.linkedin.com/in/hirun-kolongahapitiya/"  
  },
  summary:
    "A passionate Software Engineer with over two years of experience building scalable web and mobile applications using clean code practices and AI integration. Possess a proven track record of leading teams and delivering client-driven solutions. An open-source advocate and lifelong learner committed to cutting-edge development.",
  skills: {
    frontend: ["React", "Next.js", "HTML", "CSS","JavaScript","Bootstrap","Material UI"],
    backend: ["Laravel", "Node.js"],
    CMS: ["WordPress"],
    mobile: ["Flutter","Dart"],
    databases: ["MySQL", "PostgreSQL", "MongoDB", "Astra DB","Firebase"],
    cloud: ["AWS", "GCP", "Docker"],
    dataEngineering: ["SQL", "Data Engineering", "Web Scraping", "API Integration", "ETL", "Data Pipelines", "REST APIs", "Selenium", "Playwright", "BeautifulSoup", "Scrapy", "E-commerce", "Data Automation", "AI Agents"],
    aiTools: ["Python", "LangFlow", "Postman", "Git", "N8N"]
  },
  experience: [
    {
      company: "Nestable (formerly Lanka Nordic IT Partners)",
      role: "Associate Software Engineer",
      period: "Aug 2025 - May 2026",
      location: "Colombo, Sri Lanka",
      logo: "/assets/companies/nestable-logo.png",
      details:
        "Associate Software Engineer at Nestable (rebranded from Lanka Nordic IT Partners in Aug 2025), building and scaling AI-powered remote engineering solutions that help businesses seamlessly integrate high-performing technical teams. Contribute to creating flexible, cost-effective platforms that connect companies with top-tier global talent, enabling them to focus on growth while we manage the technical execution."
    },
    {
      company: "Lanka Nordic IT Partners (Pvt) Ltd - now Nestable",
      role: "Full Stack Developer",
      period: "Sep 2024 - Aug 2025",
      location: "Colombo, Sri Lanka",
      logo: "/assets/companies/lanka-nordic-logo.png",
      details:
        "Full Stack Developer at Lanka Nordic IT Partners (later rebranded to Nestable), contributing to the development of innovative AI-powered solutions and scalable full-stack applications using React, Python, Laravel, and Node.js. The company specializes in bridging Nordic tech excellence with Sri Lankan talent to deliver cutting-edge projects, including AI development and enterprise-grade web systems. Proud to be part of a team that transforms complex challenges into efficient, user-centric software while fostering collaborative growth."
    },
    {
      company: "eSupport Technologies (Pvt) Ltd",
      role: "Software Engineering Intern",
      period: "Mar 2024 - Sep 2024",
      location: "Colombo, Sri Lanka",
      logo: "/assets/companies/esupport-logo.png",
      details:
        "A passionate Software Engineering Intern at eSupport Technologies (Pvt) Ltd with hands-on expertise in PHP, Laravel, WordPress, Flutter, and JavaScript. Skilled in crafting responsive web solutions and cross-platform mobile applications. Demonstrated a strong commitment to delivering robust software while rapidly expanding technical and collaborative skills in a fast-paced environment."
    }
    
  ],
  education: {
    degree: "BICT (Hons), Business Intelligence Special",
    institution: "Uva Wellassa University of Sri Lanka",
    period: "2021-2025",
    logo: "/assets/companies/uwa-wellassa-logo.png",
  },
  thesis: {
    title:
      "Wildlife Threats Monitoring with AI-Enhanced Drone Using IoT Sensors",
    completed: "Completed Aug 2025",
    supervisors: "Prof. Y.N.S. Wijewardana; Mr. W.M.C.J.T. Kithulwatta",
    description:
      "Built an integrated conservation system combining UAV imagery (YOLOv5), IoT sensors (temperature, smoke, acoustic), and real-time dashboard (edge + cloud). Achieved strong detection performance in pilot tests, enabling early alerts for poaching, deforestation, and bushfires.",
    link: "wildasia.hirun.lk"
  },
  certifications: [
    "AI Workshop: Advanced Chatbot Development - LinkedIn Learning (2025)",
    "React: Components, Context & Accessibility - LinkedIn Learning (2025)",
    "Dart & Flutter: The Complete Flutter Development Course - Udemy (2023)",
    "Advanced WordPress Course for Professionals - Udemy (2024)"
  ],
  moreCertifications: "hirun.lk",
  languages: ["English (Fluent)", "Sinhala (Native)"],
  references: [
    {
      name: "Mr. W.M.C.J.T. Kithulwatta",
      title: "Head of the Department (Actg.), Dept. of Information and Communication Technology, Faculty of Technological Studies, Uva Wellassa University of Sri Lanka, Badulla, (90000), Sri Lanka",
      email: "chirantha@uwu.ac.lk",
      mobile: "+94 71 236 3050"
    },
    {
      name: "Mrs. W.B.M.S.C. Wijayakoon",
      title: "Lecturer (Probationary), Dept. of Information and Communication Technology, Faculty of Technological Studies, Uva Wellassa University of Sri Lanka, Badulla, (90000), Sri Lanka",
      email: "supunw@uwu.ac.lk",
      mobile: "+94 71 618 8880"
    }
  ]
};

export default cvData;
